import { FlaggedReason } from "~/redux/warehouse/bins.openApi";

export const BULK_CLEAN_BINS_CONFIRMATION_PHRASE = "UNFLAG BINS";

export const REMOVE_BIN_CONFIRMATION_PHRASE = "REMOVE BIN";

export const BULK_CLEAN_BINS_CLEANING_FLAGS: FlaggedReason[] = [
  "dirty",
  "scheduled",
  "food safety",
  "exterior maintenance"
];

export const BULK_CLEAN_BINS_HOLD_FLAGS: FlaggedReason[] = [
  "damaged",
  "misconfigured",
  "bin locked",
  "bin removed"
];

export const BULK_CLEAN_BINS_TARGET_FLAGS: FlaggedReason[] = [
  ...BULK_CLEAN_BINS_CLEANING_FLAGS,
  ...BULK_CLEAN_BINS_HOLD_FLAGS
];

export type DeleteBinFlagArgs = {
  autostoreGridId: string;
  binNumber: number;
  reason: string;
  workstationId?: string;
  deferCacheInvalidation?: boolean;
};

export type DeleteBinFlagTrigger = (args: DeleteBinFlagArgs) => {
  unwrap: () => Promise<void>;
};

export type RemoveBinFlagsArgs = {
  autostoreGridId: string;
  binNumber: number;
  flags: string[];
  workstationId?: string;
  deferCacheInvalidation?: boolean;
};

export type BulkCleanBinsProgressState = {
  totalBins: number;
  remainingBins: number;
  totalFlags: number;
  remainingFlags: number;
  currentBinId: number | null;
};
